<template>
    <div class="sl-article-grid">
        <template
            v-for="item in mergedArticles"
            :key="item.id"
        >
            <grouped-article-grid-item
                v-if="item.type === 'GROUP'"
                :group="item"
                :filter-badges="filterBadgesCallback?.(item) || []"
                :badges="badgesCallback?.(item) || []"
                :hide-unit-price="hideUnitPrice"
            />

            <article-grid-item
                v-else
                :article="item"
                :filter-badges="filterBadgesCallback?.(item) || []"
                :badges="badgesCallback?.(item) || []"
                :hide-unit-price="hideUnitPrice"
            />
        </template>

    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import ArticleGridItem from './ArticleGridItem.vue';
import GroupedArticleGridItem from './GroupedArticleGridItem.vue';

// ------------------------------------------------------------ PROPS

const props = defineProps({
    articles:
    {
        type:     Array,
        required: true,
    },

    filterBadgesCallback:
    {
        type: [Function],
        default()
        {
            // nothing
        },
    },

    badgesCallback:
    {
        type: [Function],
        default()
        {
            // nothing
        },
    },

    hideUnitPrice:
    {
        type:    Boolean,
        default: false,
    },
});

// ------------------------------------------------------------ COMPOSABLES

const store = useStore();

// ------------------------------------------------------------ COMPUTED

/**
 * All articles, with those that have a `group` extra grouped by that property.
 *
 * @type {import("vue").ComputedRef<(Object|{
 *     id:       string,
 *     type:     "GROUP",
 *     articles: Object[],
 * })[]>}
 */
const mergedArticles = computed(() =>
{
    const out = [];
    const groups = {};
    for(let i = 0; i < props.articles.length; i++)
    {
        const article = props.articles[i];
        const group = article.extra.display_group;

        if(!group)
        {
            out.push(article);
            continue;
        }

        // Pushing newly-created groups within the loop allows
        // preserving the sort order.
        if(typeof groups[group] === 'undefined')
        {
            groups[group] = {
                id:       group,
                type:     'GROUP',
                articles: [],
            };
            out.push(groups[group]);
        }

        groups[group].articles.push(article);
    }

    return out;
});

// ------------------------------------------------------------ METHODS

async function fetchImages()
{
    try
    {
        await store.dispatch('catalog/fetchImagesByArticleCodes', {
            eid:    store.state.account.cEntity.id,
            codes:  props.articles.map(a => a.code),
            format: 'T',
        });
    }
    catch(error)
    {
        // TODO: Show error
    }
}

// ------------------------------------------------------------ LIFECYCLE HOOKS

onMounted(() =>
{
    fetchImages();
});
</script>
